/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Bond Product Type
 */
export type GetBondAccountsListResponseDataItemProductsItemBondType = typeof GetBondAccountsListResponseDataItemProductsItemBondType[keyof typeof GetBondAccountsListResponseDataItemProductsItemBondType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBondAccountsListResponseDataItemProductsItemBondType = {
  BOND: 'BOND',
  NOTES: 'NOTES',
} as const;
